import React, { useEffect, useState, useRef } from 'react';
export function ProblemSolution() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const painPoints = [{
    emoji: '😰',
    title: 'is this even healthy?',
    description: 'every menu feels like a guessing game'
  }, {
    emoji: '🤯',
    title: 'does this fit my macros?',
    description: "you're doing mental math at every meal"
  }, {
    emoji: '😤',
    title: "i'll just make it work...",
    description: 'then you blow your whole day'
  }];
  return <div ref={sectionRef} className="py-32 md:py-40" data-id="element-225">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-226">
        <div className={`text-center mb-16 transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-227">
          <h2 className="text-3xl md:text-4xl font-light mb-4" data-id="element-228">
            eating out shouldn't feel like a{' '}
            <span className="text-mint-600 dark:text-mint-400" data-id="element-229">gamble</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-230">
          {painPoints.map((point, index) => <div key={index} className={`bg-black/5 dark:bg-white/5 backdrop-blur-sm rounded-3xl p-8 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{
          transitionDelay: `${index * 100}ms`
        }} data-id="element-231">
              <div className="text-4xl mb-4" data-id="element-232">{point.emoji}</div>
              <h3 className="text-xl font-light mb-2" data-id="element-233">{point.title}</h3>
              <p className="text-black/60 dark:text-white/60 leading-relaxed" data-id="element-234">
                {point.description}
              </p>
            </div>)}
        </div>
        <div className={`text-center transition-all duration-1000 delay-300 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-235">
          <p className="text-xl md:text-2xl text-black/80 dark:text-white/80 leading-relaxed" data-id="element-236">
            caltalk takes the guesswork out. just tell us what you're craving,
            and we'll find the perfect match nearby.
          </p>
        </div>
      </div>
    </div>;
}